/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![BlurBackgroundIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACGklEQVR4nN1UPU8VURBdYyRGpEM0kvgb/AMCiSEhsPNBcZ2BvITu/QgaSp6V4N+goMZCE6NRE18UQW2ETjvpIGqjmd29j7u8e/dtYaM32ebcmXNm5szdLPvvTp6vTCLpHrI8DDFgeQ2szzy24NwNIHkDrC89BqA3kbQPrM/T5Cz7yPrbRCLYqwE5y4cK6xu2vNyZQpbDMK52LGlAxLJvxCnsnFw+Lzp3q4gjPQjjhgSQ5EkYUKucS2x+vjM+qJLl0KouKq/ITdjEouOxmdtYUuRZdUwk55VZIw4rbyRP+sCJdr2prJ2/Qu6cG7MOgeQbsHxF1p5hWZZdQtYNTx7brFaVI2uvxGtfL8yPbdYIk/Nr56Moqq4JGObvWxkdmuwTnHPXRwnMrq1d9ZvVyotwM4hkLjUiIN0sRktyvxrLQStyP0dg/egTSpO1Z1VfMNm62zHy4E30oybXyEk/2X+lsZrqEK3etdwLPrwdCrT18uT2/D2+tOSmgWQbWY+B5Jd9SHIEpFuIetvHIctu+MKHBJD0BbC8C8kRH8wgy0lkRb0P34nkXtmJzCHp+yh57FjlTeShSNhJ4/HGVSPbHkUeiGyVHeNE0mRvkt8cm3NF8KOBvLgD0i+Wk+fuTtJkU7bLwfqRngHpTyBZT1cu62WMnllOt9u9AqxPoxtobZmyc+5yIcjy2Hbcfs3IehoROLUlKN4By6NWHvyT5w8TI+6iarej7gAAAABJRU5ErkJggg==)
 */
export const BlurBackgroundIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.7 2.3a1 1 0 0 1 0 1.4l-4.92 4.93c-.12.12-.33.09-.41-.06-.23-.42-.52-.8-.85-1.13a.26.26 0 0 1-.01-.36l4.78-4.79a1 1 0 0 1 1.42 0ZM20 20.6c0 .26.36.45.55.27l1.16-1.16a1 1 0 0 0-1.42-1.42l-.4.41a.25.25 0 0 0-.07.24c.12.53.18 1.09.18 1.66ZM4 20.6c0 .2.02.4.05.6a.26.26 0 0 1-.07.23l-.27.28a1 1 0 0 1-1.42-1.42l1.35-1.34c.19-.19.53.01.48.27-.08.45-.12.91-.12 1.38ZM16.7 3.7l-2.58 2.6a.26.26 0 0 1-.28.05A4.99 4.99 0 0 0 12 6c-.15 0-.23-.18-.13-.29L15.3 2.3a1 1 0 1 1 1.42 1.42ZM7 11c0-.15-.18-.23-.29-.13L2.3 15.3a1 1 0 1 0 1.42 1.42l3.58-3.6c.08-.06.1-.17.06-.27A4.99 4.99 0 0 1 7 11ZM18.23 15.36c-.1.1-.1.24-.02.35.32.37.6.77.83 1.2.09.14.29.18.41.05l2.26-2.25a1 1 0 0 0-1.42-1.42l-2.06 2.07ZM21.7 9.7l-4.62 4.64a.26.26 0 0 1-.33.03l-.45-.3a.27.27 0 0 1-.09-.37c.38-.6.64-1.27.74-2 0-.05.03-.1.07-.14L20.3 8.3a1 1 0 1 1 1.42 1.42ZM11.7 2.3a1 1 0 0 1 0 1.4l-8 8a1 1 0 0 1-1.4-1.4l8-8a1 1 0 0 1 1.4 0ZM6.7 3.7a1 1 0 0 0-1.4-1.4l-3 3a1 1 0 0 0 1.4 1.4l3-3ZM15 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM6 20.6c0-3.1 2.5-5.6 5.6-5.6h.8c3.1 0 5.6 2.5 5.6 5.6 0 .77-.63 1.4-1.4 1.4a.17.17 0 0 1-.16-.12c-.19-.7-.44-1.36-.68-1.89-.11-.24-.43-.15-.4.12l.08.8a1 1 0 0 1-1 1.09H9.55a1 1 0 0 1-.99-1.1l.08-.79c.03-.27-.29-.36-.4-.12-.24.53-.5 1.19-.68 1.89a.17.17 0 0 1-.16.12A1.4 1.4 0 0 1 6 20.6Z"
        className={colorClass}
      />
    </svg>
  );
};
